import { useSearchParams } from 'external/react';
import useAdmin from 'context/admin-context/hook';
import PurchaseTabs from './PurchaseTabs';
import PurchaseDetail from './PurchaseDetail';
import ChangeCourseModal from './PurchaseDetail/CourseList/ChangeCourseModal';

const ClientPurchases = () => {
  const { state, changeClientCourse } = useAdmin();
  const purchases = state.client.purchases.items;
  const [searchParams] = useSearchParams();
  const selected = Math.min(Number(searchParams.get('purchaseIndex') ?? 0), purchases.length - 1);

  if (purchases.length === 0) {
    return (
      <div className="d-flex flex-column align-items-center justify-content-center text-muted" style={{ height: 200 }}>
        <span style={{ fontSize: '2rem' }}>🛒</span>
        <p className="mt-2 mb-0">Este cliente no tiene compras registradas.</p>
      </div>
    );
  }

  return (
    <div className="mt-2" style={{ display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
      <ChangeCourseModal onSave={async ({originalCourse, newCourse, source}) => {
        const clientId = state.client.id
        const {id: purchaseId} = purchases[selected]
        await changeClientCourse({clientId, purchaseId, currentCourse: originalCourse, newCourse, extra: source === 'extra'})
        window.location.reload()
      }} />
      <PurchaseTabs />
      <div style={{
        flexGrow: 1,
        border: '1px solid #dee2e6',
        borderRadius: '0 0 0.375rem 0.375rem',
        borderTop: 0,
        padding: '1rem',
      }}>
        <PurchaseDetail index={selected} />
      </div>
    </div>
  );
};

export default ClientPurchases;